module.exports = __webpack_public_path__ + "static/img/a031.61ca695.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a031.jpg
// module id = wBFO
// module chunks = 0